import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";

import img1 from "../../../Assets/wf-icon.svg";
import "../Node_Edge_Components.css";
 

const SvgImageRowSub = forwardRef((props, ref) => {
  const { searchText, selectedSvg, expandedSvg, createEvent, selectedEventLevel } = props;
  const [allIcons, setAllIcons] = useState(false);
  const [eventTemp, setEventTemp] = useState([]);
  const [legend, setLegend] = useState([]);

  const getEventTemplates = async () => {
    const levels = Array.isArray(selectedEventLevel) ? selectedEventLevel : [];
    setEventTemp(
      levels.map((item) => ({
        img: img1,
        value: item.calloutName,
        eventId: item.id,
        assignTo: item.primaryEventTypeName,
        textColor: item.primaryEventTypeColor,
        eventDetails: {
          primaryEventId: item.primaryEventId,
          primaryEventName: item.primaryEventCode,
          selectedEventName: item.calloutName,
          eventId: item.id,
          isActive: item.isActive,
          isPublished: item.isPublished,
        },
      }))
    );
    const uniqueTypes = Array.from(new Set(levels.map((item) => item.primaryEventTypeName))
    ).map((typeName) => {
      const item = levels.find(
        (i) => i.primaryEventTypeName === typeName
      );
      return {
        name: typeName,
        color: item?.primaryEventTypeColor,
      };
    });
    setLegend(uniqueTypes);
  };


  useEffect(() => {
    if (Array.isArray(selectedEventLevel) && selectedEventLevel.length > 0) {
      getEventTemplates();
    }
  }, [selectedEventLevel]);


  /* --------------------------------------------------
     EXPOSE LEGEND TO SIDEBAR
  -------------------------------------------------- */
  useImperativeHandle(ref, () => ({
    legend,
  }));

  /* --------------------------------------------------
     FILTER EVENTS
  -------------------------------------------------- */
  const filteredSvg = eventTemp.filter((icon) =>
    icon.value.toLowerCase().includes(searchText.toLowerCase())
  );

  /* --------------------------------------------------
     🔥 FIXED DRAG START (MOST IMPORTANT PART)
  -------------------------------------------------- */
  const handleDragStart = (
    event,
    value,
    eventDetails,
    assignTo
  ) => {
    // REQUIRED BY REACT FLOW
    event.dataTransfer.setData(
      "application/reactflow",
      "eventNode"
    );

    // CUSTOM DATA
    event.dataTransfer.setData(
      "eventDetails",
      JSON.stringify(eventDetails)
    );
    event.dataTransfer.setData("label", value);
    event.dataTransfer.setData("assignTo", assignTo);

    event.dataTransfer.effectAllowed = "move";
  };



  const trimText = (text, maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };
  /* --------------------------------------------------
     RENDER
  -------------------------------------------------- */
  return (
    <div>
      {eventTemp.length > 0 ? (
        <div className={!allIcons ? "selected-svg-scrollbar" : "scrollbar"}>
          {filteredSvg
            .slice(0, allIcons ? eventTemp.length : eventTemp.length)
            .map((img, index) => (
              <div
                key={index}
                draggable
                onDragStart={(event) =>
                  handleDragStart(
                    event,
                    img.value,
                    img.eventDetails,
                    img.assignTo
                  )
                }
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "5px",
                   //background: "#fff",
                  borderRadius: "4px",
                  height: "100%",
                  cursor: "grab",
                   overflow: "hidden",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderColor: "#f0dfdf"
                }}
              >
                <div
                  style={{
                    width: "22px",
                    //backgroundColor: img.textColor,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTopLeftRadius: "4px",
                    borderBottomLeftRadius: "4px",
                  }}
                >
                  <img
                    src={img.img}
                    alt={img.value}
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>

                <p style={{ color: "#fff", textAlign: "left", border: "1" }}
                >
                  {trimText(img.value, 75)}

                </p>
              </div>
            ))}
        </div>
      ) : (
        <p style={{ color: "#fff", textAlign: "center" }}>
          No Events available...
        </p>
      )}

    </div>
  );
});

export default SvgImageRowSub;
